import client from '@/api/server';
import { ActionContext } from '@/store/types';
import { State } from '..';
import { Country } from '@/api/validators/content';
import { getLocalCountry } from '@/helpers/utils';

export const stateOthers = {
  countries: [] as Country[],
  countryCode: undefined as string | undefined,
};

export const mutationsOthers = {
  setCountries(state: State, countries: Country[]) {
    state.countries = countries;
  },
  setCountryCode(state: State, country: string) {
    state.countryCode = country;
  },
};

export const actionsOthers = {
  async fetchCountries(context: ActionContext) {
    const countries = await client.fetchCountries();
    context.commit('setCountries', countries);
  },
  async fetchCountryCode(context: ActionContext) {
    const countryCode = await getLocalCountry();
    context.commit('setCountryCode', countryCode);
  },
};
